<template lang="pug">
  div.input-field
    slot(name="label" v-bind:label="label" v-if="label")
      label.input-field__label(:for="inputId" v-if='required')
        | {{label + ' '}}
        span.input-field__label-tooltip * <span>Обязательное поле</span>
      label.input-field__label(:for="inputId" v-else) {{label}}
    textarea.input-textarea(:id="inputId" v-bind:placeholder="placeholder" v-model="inputVal" @change="changeHandler")
</template>

<script>
  export default {
    name: 'InputTextarea',
    props: {
      view: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: null
      },
      event: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      viewClassName: function () {
        return `input-field_view-${this.$props.view}`;
      }
    },
    methods: {
      changeHandler: function () {
        if (!this.$props.event) {
          return false
        }
        this.$parent.$emit(this.$props.event, this.inputVal)
      }
    },
    data: function () {
      return {
        inputId: `input-${Math.random()}`,
        inputVal: null
      }
    }
  }
</script>

<style lang="scss" src="./assets/input-textarea.scss"></style>
